import { ReactNode, useEffect, useState } from "react";
import { connect } from "react-redux";
import { dispatchToggle } from "../../actions/ToggleActions";
interface GenericToggleComponentProps {
    schoolCode: string,
    toggles: any,
    toggleReduxName: string,
    retrieveToggleValue: () => Promise<boolean>,
    defaultComponent: ReactNode,
    toggledComponent: ReactNode,
    dispatchToggle: (toggleName: string, getValue: () => Promise<boolean>) => Promise<void>
}

const GenericToggleComponent = ({ schoolCode, toggles, toggleReduxName, retrieveToggleValue,
    defaultComponent, toggledComponent, dispatchToggle }: GenericToggleComponentProps) => {

    const [useToggled, setUseToggled] = useState<boolean | null>(null);
    const [toggleValue, setToggleValue] = useState(toggles?.[toggleReduxName]);
   
    // Using a state variable since toggles as a dependency in the next useEffect 
    // would result in a bunch of repeated dispatchToggle commands
    useEffect(() => {
        setToggleValue(toggles?.[toggleReduxName]);
    }, [toggles, toggleReduxName]);

    useEffect(() => {
        setToggleValue(undefined);
    }, [schoolCode]) 

    useEffect(() => {
        let toggleHasValue = toggleValue !== undefined && toggleValue !== null && toggleValue !== "";

        if (toggleHasValue) {
            setUseToggled(toggleValue);
        } else {
            dispatchToggle(toggleReduxName, retrieveToggleValue);
        }
    }, [toggleValue, toggleReduxName, retrieveToggleValue, dispatchToggle]);

    if(useToggled != null){
        return useToggled ? toggledComponent : defaultComponent;
    } else {
        return <></>
    }
};

const mapStateToProps = (state: any) => {
    return {
        toggles: state.toggles,
        schoolCode: state.school?.schoolCode
    };
};

export default connect(mapStateToProps, {
    dispatchToggle
})(GenericToggleComponent);
